import { FC } from 'react';

const NotFoundCommonPage: FC = () => {
  return <h2>NotFound</h2>;
};

export default NotFoundCommonPage;
